import React from 'react';
import { connect } from 'react-redux';
import { scrollToUrlHash, scrollToElement } from '../../../services/forms/scroller';

import PageMeta from '../../modules/PageMeta';
import PageSection from '../../modules/PageSection';
import SidebarColumn from '../../modules/SidebarColumn';
import ContentColumn from '../../modules/ContentColumn';
import Page from '../../pages/Page';

import * as licenceActions from '../../../actions/licences';
import PageHeader from "../../modules/PageHeader/index";

import styles from './styles.scss';

const scrollToLicenceSection = (e, querySelector) => {
    e.preventDefault();
    window.location.hash = querySelector;
    scrollToElement('#' + querySelector);
}

const LicenceNav = ({bookmarks, className = ''}) => {
    return (
        <nav className={styles['bookmarks'] + ' ' + className}>
            <ul>
                {bookmarks.map(b => {
                    return (
                        <li key={b.id}>
                            <a onClick={(e) => {
                                scrollToLicenceSection(e, `${b.id}`)
                            }} href={`#${b.id}`}>{ b.name }</a>
                        </li>
                    )
                })}
            </ul>
        </nav>
    )
}

class ViewLicence extends React.Component {
    componentDidMount() {
        this._loadLicence()
            .then(scrollToUrlHash);
    }

    _loadLicence() {
        if (this._getLicenceType()) {
            return this.props.refreshServiceLicence(this._getServiceId(), this._getLicenceType());
        } else {
            return this.props.refreshLicence(this._getLicenceId());
        }
    }

    _getServiceId() {
        return this._getLicenceId();
    }

    _getLicenceId() {
        return this.props.match.params.id;
    }

    _getLicenceType() {
        return this.props.match.params.licenceType;
    }

    render() {
        const {bookmarks} = this.props;

        return (
            <Page>
                <PageMeta title="View Licence" />

                <ContentColumn className={styles['content']}>
                    {bookmarks && bookmarks.length > 0 &&
                        <SidebarColumn>
                            <LicenceNav bookmarks={bookmarks}/>
                        </SidebarColumn>
                    }

                    <div>
                        {this.props.licence && (
                            <PageHeader>
                                <h1>{this.props.licence.name}</h1>
                            </PageHeader>
                        )}

                        {bookmarks && bookmarks.length > 0 &&
                            <LicenceNav bookmarks={bookmarks} className={styles['bookmarks--mobile']}/>
                        }

                        <PageSection>
                            {this.props.licence &&
                                <div className="licence-viewer" dangerouslySetInnerHTML={{__html: this.props.licence.content}} />
                            }
                        </PageSection>
                    </div>
                </ContentColumn>
            </Page>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        licence: state.licences.licence,
        bookmarks: state.licences.licenceBookmarks
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        refreshLicence(id) {
            return dispatch(licenceActions.refreshLicence(id));
        },
        refreshServiceLicence(serviceId, licenceType) {
            return dispatch(licenceActions.refreshServiceLicence(serviceId, licenceType));
        }
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(ViewLicence);